import { createFileRoute, notFound, useRouter } from "@tanstack/react-router";

import { requisitesDetailsQueryOptions } from "@entities/requisites/hooks/use-requisites-details";
import { RequisitesDetailsPageConnector } from "@pages/requisites-details";

export const Route = createFileRoute("/_private/requisites/$id")({
  component: RouteComponent,
  loader: async ({ context, params }) => {
    try {
      return await context.queryClient.ensureQueryData(
        requisitesDetailsQueryOptions({ id: params.id }),
      );
    } catch (e) {
      throw notFound();
    }
  },
});

function RouteComponent() {
  const { id } = Route.useParams();
  const router = useRouter();

  return (
    <RequisitesDetailsPageConnector id={id} onGoBack={router.history.back} />
  );
}
